import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/new',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/PracticeTemplateNewContainer',
      './modules/practiceTemplateNew'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PracticeTemplateNew = require('./containers/PracticeTemplateNewContainer').default
      const actions = require('./modules/practiceTemplateNew')
      const reducer = require('./modules/practiceTemplateNew').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'practiceTemplateNew', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchFeatures())
      /*  Return getComponent   */
      cb(null, PracticeTemplateNew)

    /* Webpack named bundle   */
    }, 'practiceTemplateNew')
  }
})



// WEBPACK FOOTER //
// ./src/routes/PracticeTemplateNew/index.js